module.exports = __webpack_public_path__ + "img/customer03.9e519d6.png";